import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
//  import profileImage from "profile.png";
import { FaPhoneAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import { useCallback } from "react";


const OrderDetail = ({ expanded }) => {
    const [lead, setLead] = useState(null);
    const { id } = useParams();
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const module = "Manual_Calls";
    const [selectedRelatedList, setSelectedRelatedList] = useState(null);
    const [calls, setCalls] = useState([]);
    const [showEditModal, setShowEditModal] = useState(false);
    const [dueDateTime, setDueDateTime] = useState("");




    const notesRef = useRef(null);

    const handleRelatedListClick = (name) => {
        setSelectedRelatedList(name);

        if (name === "Notes" && notesRef.current) {
            notesRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };



    const idToFetch = id;

    const fetchLeadData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await fetch(`/server/dealer_backend/getSpecificTask?id=${idToFetch}`);
            const data = await response.json();

            if (data.status === "success") {
                const filteredLead = data.data.find((item) => item.id === idToFetch);
                setLead(filteredLead || data.data[0]);
            } else {
                // console.error("Error fetching data:", data.error);
            }
        } catch (error) {
            // console.error("Failed to fetch task data:", error);
        } finally {
            setLoading(false);
        }
    }, [idToFetch]);

    // ✅ Call fetchLeadData on mount
    useEffect(() => {
        fetchLeadData();
    }, [fetchLeadData]);



    const [textFont, setTextFont] = useState("");



    useEffect(() => {
        if (lead?.Due_Date) {
            const dueDate = new Date(lead.Due_Date);
            const today = new Date();
            // for not showing today as due_date as overdue

            today.setHours(0, 0, 0, 0);
            dueDate.setHours(0, 0, 0, 0);

            if (today > dueDate) {
                const diffTime = Math.abs(today - dueDate);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Convert milliseconds to days

                setTextFont("Your task has been overdue for " + diffDays + (diffDays === 1 ? " day." : " days."));
            }

        }
    }, [lead]);







    const LeadField = ({ label, value, icon }) => (
        <div className="form-group-field2">
            <label>{label}</label>
            <span>
                {icon && <span className="icon">{icon}</span>}
                {value || "—"}
            </span>
        </div>
    );



    const formatSize = (bytes) => {
        if (!bytes) return "—";
        const kb = bytes / 1024;
        return kb < 1024
            ? `${kb.toFixed(1)} KB`
            : `${(kb / 1024).toFixed(2)} MB`;
    };




    const formatDate = (isoString) => {
        const date = new Date(isoString);
        return date.toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    };


    const [isMarkingComplete, setIsMarkingComplete] = useState(false);

    const [showClosePopup, setShowClosePopup] = useState(false);
    const [closeDescription, setCloseDescription] = useState("");


    const handleCloseTask = async () => {
        try {
            const res = await fetch(`/server/dealer_backend/closeTask`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ taskId: idToFetch, description: closeDescription }),
            });

            const result = await res.json();

            if (result.status === "success") {
                toast.success("Task marked as completed!");
                setShowClosePopup(false);

                // ✅ Option 1: Update status immediately
                setLead((prev) => ({
                    ...prev,
                    status: "Completed",
                }));

                // ✅ Option 2: Re-fetch data from server (comment above option if you prefer this)
                await fetchLeadData();

            } else {
                toast.error("Failed to close task.");
            }
        } catch (error) {
            // console.error("Error closing task:", error);
            toast.error("An error occurred.");
        }
    };


    const handleEditSubmit = async () => {
        if (!dueDateTime) return alert("Please select due date & time");

        try {
            setLoading(true);

            // Convert datetime-local → timezone-aware ISO string
            const localDate = new Date(dueDateTime);
            const timezoneOffset = -localDate.getTimezoneOffset();
            const sign = timezoneOffset >= 0 ? "+" : "-";
            const pad = (n) => String(Math.floor(Math.abs(n))).padStart(2, "0");

            const hoursOffset = pad(timezoneOffset / 60);
            const minutesOffset = pad(timezoneOffset % 60);

            const formattedDateTime =
                localDate.getFullYear() +
                "-" +
                pad(localDate.getMonth() + 1) +
                "-" +
                pad(localDate.getDate()) +
                "T" +
                pad(localDate.getHours()) +
                ":" +
                pad(localDate.getMinutes()) +
                ":00" +
                sign +
                hoursOffset +
                ":" +
                minutesOffset;

            const payload = {
                data: [
                    {
                        Due_Date_Time: formattedDateTime,
                    },
                ],
            };

            const res = await fetch(
                `/server/dealer_backend/edit-taskDetails/${lead?.id}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            const result = await res.json();

            if (!res.ok) {
                throw new Error(result?.error || "Failed to update task");
            }

            toast.success("Task updated successfully");
            setShowEditModal(false);
            await fetchLeadData();

        } catch (error) {
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };







    const vari = `${lead?.subject || ''}`.trim();


    const toDateTimeLocal = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const tzOffset = date.getTimezoneOffset() * 60000;
        return new Date(date.getTime() - tzOffset)
            .toISOString()
            .slice(0, 16);
    };


    useEffect(() => {
        if (showEditModal && lead?.dueDateTime) {
            setDueDateTime(toDateTimeLocal(lead.dueDateTime));
        }
    }, [showEditModal, lead?.dueDateTime]);







    return (

        loading ? (
            <div className="loading-circle flex justify-center items-center h-screen">
                <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
            </div>
        ) : (
            <React.Fragment>
                <ToastContainer position="top-right" autoClose={3000} />
                <header style={{
                    position: 'fixed',
                    top: 0,
                    left: expanded ? '5rem' : '16rem',
                    right: 0,
                    height: '5rem',
                    backgroundColor: 'white',
                    zIndex: 1000,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '1rem',
                    borderBottom: '1px solid #e5e7eb',
                }} className="header-fixed mobile-header bg-white h-screen overflow-auto border-b px-6 py-4 flex items-center justify-between">
                    <div className="flex items-center space-x-2 min-w-0">
                        <button
                            className="text-gray-600 hover:text-black text-lg"
                            onClick={() => navigate('/tasks')}  // Go back one step in browser history
                            aria-label="Go back"
                        >
                            <ArrowLeft />
                        </button>


                        <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold text-lg shrink-0">
                            {(vari.charAt(0)?.toUpperCase()) || ''}
                        </div>

                        {/* Subject with first two words only + ellipsis */}
                        <h1
                            className="text-lg font-semibold truncate"
                            style={{ maxWidth: '8rem' }} // controls how much width it can take
                        >
                            {`${lead?.subject || ''}`.trim().split(/\s+/).slice(0, 2).join(' ')}
                        </h1>
                    </div>


                    <div className="flex items-center justify-end flex-shrink-0 gap-2">
                        {/* Edit Task Button */}
                        <button
                            className="bg-yellow-500 text-white px-2 py-1 text-sm sm:px-4 sm:py-2 sm:text-base rounded-lg hover:bg-yellow-600 transition"
                            onClick={() => setShowEditModal(true)}
                        >
                            Edit Task
                        </button>

                        {/* Close Task Button */}
                        <button
                            className={`rounded-lg transition shrink-0 
        ${lead?.status === "Completed"
                                    ? "bg-gray-400 text-white cursor-not-allowed"
                                    : "bg-blue-600 text-white hover:bg-blue-700"
                                }
        px-2 py-1 text-sm
        sm:px-4 sm:py-2 sm:text-base`}
                            disabled={lead?.status === "Completed"}
                            onClick={() => {
                                if (lead?.status !== "Completed") {
                                    setShowClosePopup(true);
                                }
                            }}
                            style={{ marginRight: "20px" }}
                        >
                            {lead?.status === "Completed" ? "Task Completed" : "Close Task"}
                        </button>
                    </div>




                </header>
                <div className="flex">
                    <aside
                        style={{
                            position: 'fixed',
                            top: '4rem',
                            left: expanded ? '16rem' : '16rem',
                            bottom: 0,
                            backgroundColor: 'white',
                            padding: '1rem',
                            borderRight: '1px solid #e5e7eb',
                            overflowY: 'auto',
                        }}
                        className="related-list header-fixed w-64 bg-white border-r p-4 min-h-screen max-[1020px]:hidden"
                    >
                        <div className="bg-gray-50 rounded-lg shadow-md p-4 space-y-4">
                            {/* Header */}
                            <h4 className="font-semibold text-blue-700 text-base tracking-wide border-b border-gray-200 pb-2">
                                Task Summary
                            </h4>

                            {/* Summary Fields */}
                            <div className="space-y-2 text-sm">
                                <div className="flex justify-between">
                                    <span className="font-medium text-gray-600">Status:</span>
                                    <span>{lead?.status || "—"}</span>
                                </div>

                                <div className="flex justify-between">
                                    <span className="font-medium text-gray-600">Priority:</span>
                                    <span>{lead?.priority || "—"}</span>
                                </div>

                                <div className="flex justify-between">
                                    <span className="font-medium text-gray-600">Due:</span>
                                    <span>
                                        {lead?.dueDateTime
                                            ? new Date(lead.dueDateTime).toLocaleDateString()
                                            : "—"}
                                    </span>
                                </div>

                                <div className="flex justify-between">
                                    <span className="font-medium text-gray-600">Existing Donor:</span>
                                    <span className="text-right">
                                        {lead?.whoId?.id ? (
                                            <Link
                                                to={`/app/contact-details/${lead.whoId.id}`}
                                                className="text-blue-600 hover:underline"
                                            >
                                                {lead.whoId.name || "—"}
                                            </Link>
                                        ) : (
                                            "—"
                                        )}
                                    </span>
                                </div>

                                <div className="flex justify-between">
                                    <span className="font-medium text-gray-600">Related To:</span>
                                    {lead?.whatId?.id ? (
                                        <a
                                            href={`/app/owner-details/${lead.whatId.id}`} // 🔥 direct link
                                            className="text-blue-600 hover:underline"
                                        >
                                            {lead.whatId.name}
                                        </a>
                                    ) : (
                                        <span>—</span>
                                    )}
                                </div>

                            </div>

                            {/* Hint/Footer */}
                            <div className="text-xs text-gray-400 text-center pt-2 border-t border-gray-200">
                                Tip: Add related contacts or notes to enrich this panel.
                            </div>
                        </div>
                    </aside>






                    <main style={{
                        // marginTop: '4rem',
                        // marginLeft: '14rem',
                        // height: 'calc(100vh - 4rem)',
                        // overflowY: 'auto',
                        padding: '1rem',
                        flexGrow: 1,
                    }}>
                        <div className="call-maindiv  lead-container p-4 flex-1">

                            {/* Lead Status Card */}











                            {/* Lead Information Card */}



                            <div className="lead-container2">
                                <h3 className="lead-title">Task Information</h3>
                                <hr className="lead-divider" />
                                {lead && (
                                    <div className="table-mobile grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700 break-words">
                                        {/* Left Column */}
                                        <div className="space-y-3">
                                            <LeadField label="Subject" value={lead?.subject || "—"} />
                                            <LeadField
                                                label="Due Date Time"
                                                value={
                                                    lead.dueDateTime
                                                        ? new Date(lead.dueDateTime).toLocaleString(undefined, {
                                                            year: "numeric",
                                                            month: "long",
                                                            day: "numeric",
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            hour12: true,
                                                        })
                                                        : "—"
                                                }
                                            />

                                            <LeadField label="Phone" value={lead?.phone || "—"} />
                                            {/* <LeadField label="Due Date" value={lead?.dueDate || "—"} /> */}
                                            <LeadField
                                                label="Existing Donor"
                                                value={
                                                    lead?.whoId?.id ? (
                                                        <Link
                                                            to={`/contact-details/${lead.whoId.id}`}
                                                            className="text-blue-600 hover:underline"
                                                        >
                                                            {lead.whoId.name || "—"}
                                                        </Link>
                                                    ) : (
                                                        "—"
                                                    )
                                                }
                                            />
                                            <LeadField
                                                label="Related To"
                                                value={
                                                    lead?.whatId?.id ? (
                                                        <Link
                                                            to={`/records/${lead.whatId.id}`} // 🔥 redirect path
                                                            className="text-blue-600 hover:underline cursor-pointer"
                                                        >
                                                            {lead.whatId.name}
                                                        </Link>
                                                    ) : (
                                                        "—"
                                                    )
                                                }
                                            />

                                            <LeadField label="Status" value={lead?.status || "—"} />


                                        </div>

                                        {/* Right Column */}
                                        <div className="space-y-3">
                                            <LeadField label="Follow Up Type" value={lead?.followUpType || "—"} />
                                            <LeadField label="Priority" value={lead?.priority || "—"} />
                                            <LeadField
                                                label="Created Time"
                                                value={
                                                    lead?.createdTime
                                                        ? ` ${new Date(lead.createdTime).toLocaleString()}`
                                                        : "—"
                                                }
                                            />
                                            <LeadField
                                                label="Closed Time"
                                                value={
                                                    lead?.closedTime
                                                        ? new Date(lead.closedTime).toLocaleString("en-IN", {
                                                            timeZone: "Asia/Kolkata",
                                                            year: "numeric",
                                                            month: "short",
                                                            day: "2-digit",
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            second: "2-digit",
                                                            hour12: true
                                                        })
                                                        : "—"
                                                }
                                            />

                                            {/* <LeadField label="Repeat" value={lead?.recurringActivity || "—"} />
                                            
                                            <LeadField label="Reminder" value={lead?.reminder || "—"} /> */}

                                        </div>
                                    </div>
                                )}

                            </div>

                            <div className="lead-container2">
                                <h3 className="lead-title">Description Information</h3>
                                <hr className="lead-divider" />
                                {lead && (
                                    <div className="table-mobile grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700 break-words">
                                        <LeadField label="Description" value={lead?.description || "—"} />
                                    </div>
                                )}
                            </div>




                            {showClosePopup && (
                                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
                                    <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] max-w-md text-center">
                                        <p className="text-lg font-medium mb-4">Are you sure you want to mark this task as completed?</p>

                                        {/* Description Textarea */}
                                        <textarea
                                            className="w-full border rounded p-2 mb-4 text-left text-gray-700"
                                            placeholder="Add a closing note or description..."
                                            rows={4}
                                            value={closeDescription}
                                            onChange={(e) => setCloseDescription(e.target.value)}
                                        />

                                        <div className="flex justify-center space-x-4">
                                            <button
                                                className={`px-4 py-2 rounded text-white ${isMarkingComplete ? "bg-blue-300 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}`}
                                                onClick={() => {
                                                    if (!isMarkingComplete) {
                                                        setIsMarkingComplete(true);
                                                        handleCloseTask();
                                                    }
                                                }}
                                                disabled={isMarkingComplete}
                                            >
                                                Mark as Completed
                                            </button>

                                            <button
                                                className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
                                                onClick={() => setShowClosePopup(false)}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}



                            {showEditModal && (
                                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                                    <div className="bg-white rounded-lg p-6 w-full max-w-md">
                                        <h2 className="text-lg font-semibold mb-4">Edit Task</h2>

                                        <label className="block mb-2 text-sm font-medium">
                                            Due Date & Time
                                        </label>
                                        <input
                                            type="datetime-local"
                                            className="w-full border rounded-lg px-3 py-2 mb-4"
                                            value={dueDateTime}
                                            onChange={(e) => setDueDateTime(e.target.value)}
                                        />

                                        <div className="flex justify-end gap-2">
                                            <button
                                                className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400"
                                                onClick={() => setShowEditModal(false)}
                                            >
                                                Cancel
                                            </button>

                                            <button
                                                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                                                disabled={loading}
                                                onClick={handleEditSubmit}
                                            >
                                                {loading ? "Updating..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
















                        </div>

                    </main>

                </div>
            </React.Fragment>
        )


    );
};

export default OrderDetail;
